import ApiService from '@/core/services/api.service';

const $api = new ApiService();

export const getWeekList = (userPackageId) => $api.get(`CoachNote/${userPackageId}/weeks`);

export const getWeekDetail = (userPackageId, weekNumber) =>
  $api.get(`CoachNote/${userPackageId}/week/${weekNumber}`);

export const saveExamination = (payload) => $api.post('CoachNote/examination', payload);

export const saveTracking = (payload) => $api.post('CoachNote/tracking', payload);

export const saveWeeklyActions = (payload) => $api.post('CoachNote/weekly-actions', payload);
export const deleteWeeklyAction = (id) => $api.delete(`CoachNote/weekly-action/${id}`);

export const getKpiInputs = (userPackageId, date) =>
  $api.get(`CoachNote/${userPackageId}/kpi-inputs`, { params: { date } });

export const getKpiInputsByRange = (userPackageId, startDate, endDate) =>
  $api.get(`CoachNote/${userPackageId}/kpi-inputs-range`, { params: { startDate, endDate } });

export const getCustomerInfo = (userPackageId) => $api.get(`CoachNote/${userPackageId}/customer-info`);

export const getCharts = (userPackageId) => $api.get(`CoachNote/${userPackageId}/charts`);

export const getHistory = (userPackageId) => $api.get(`CoachNote/${userPackageId}/history`);

export const getBaseline = (userPackageId) => $api.get(`PatientBaseline/${userPackageId}`);

export const saveBaseline = (payload) => $api.post('PatientBaseline/baseline', payload);

export const saveGoalNote = (payload) => $api.post('PatientBaseline/goal', payload);

export const getSampleMenuFiles = (userPackageId) => $api.get(`PatientBaseline/${userPackageId}/sample-menus`);
export const uploadSampleMenuFiles = (formData) =>
  $api.post('PatientBaseline/sample-menus', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteSampleMenuFile = (id) => $api.delete(`PatientBaseline/sample-menus/${id}`);

export const getActionPlans = (userPackageId) => $api.get(`ActionPlan/${userPackageId}`);

export const saveActionPlans = (payload) => $api.post('ActionPlan', payload);
export const deleteActionPlan = (id) => $api.delete(`ActionPlan/${id}`);

export const getUserPackage = (userPackageId) => $api.get(`UserPackage/${userPackageId}`);

export const getProgramStatus = (userPackageId) => $api.get(`CoachNoteProgram/${userPackageId}`);
export const getProgramLogs = (userPackageId) => $api.get(`CoachNoteProgram/${userPackageId}/logs`);
export const updateProgramStatus = (userPackageId, payload) => $api.post(`CoachNoteProgram/${userPackageId}/status`, payload);
export const evaluateProgram = (userPackageId, payload) => $api.post(`CoachNoteProgram/${userPackageId}/evaluate`, payload);

export const getDashboardFilters = () => $api.get('CoachNoteDashboard/filters');
export const getDashboard = ({ fromDate, toDate, servicePackageIds = [], coachIds = [] }) => {
  const params = new URLSearchParams();
  if (fromDate) params.append('fromDate', fromDate);
  if (toDate) params.append('toDate', toDate);
  servicePackageIds.forEach(id => params.append('servicePackageIds', id));
  coachIds.forEach(id => params.append('coachIds', id));
  return $api.get(`CoachNoteDashboard?${params.toString()}`);
};
